<template>
  <v-btn icon v-on:click="dialog = true" density="compact" color="green">
    <v-icon :icon="['fas', 'arrow-right-to-city']" />
    <v-tooltip activator="parent" location="bottom">
       Сменить подразделение
    </v-tooltip>
  </v-btn>


  <v-dialog persistent width="450" style="backdrop-filter: blur(1px)" v-model="dialog">
    <template v-slot:default>
      <v-card rounded="xl">
        <template v-slot:title>
          СМЕНИТЬ ПОДРАЗДЕЛЕНИЕ
        </template>
        <template v-slot:text>
          <v-btn
              flat
              color="green"
              block
              rounded="xl"
              text="ВЫБРАТЬ"
              @click="go_to_select()"
          />
        </template>
        <template v-slot:actions>
          <v-spacer />
          <v-btn
              rounded="xl"
              text="ЗАКРЫТЬ"
              @click="dialog = false"
          />
          <v-spacer />
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import {HideWeekends, ShortenNames, ShowAllDay} from "@/store/wp_planner/settings.store";
import { District__Guid, DistrictsList } from "@/store/global/districts.dictionary";

export default {
  name: "Settings__WP_Dialog",
  data() {
    return {
      dialog: false,
      labels: {
        week: {
          0: '7 Дней',
          1: '5 Дней'
        }
      }
    }
  },
  methods: {
    go_to_select: function () {
      this.$router.push({ name: 'wp__select' })
    }
  },
  computed: {
    districts: {
      get() {
        return DistrictsList().get()
      },
      set(value) {
        DistrictsList().set(value)
      }
    },
    district_guid: {
      get() {
        return District__Guid().get()
      },
      set(value) {
        District__Guid().set(value)
      }
    },
    hidden_weekends: {
      get() {
        return HideWeekends().get()
      },
      set(v) {
        HideWeekends().set(v)
      }
    },
    shorten_names: {
      get() {
        return ShortenNames().get()
      },
      set(v) {
        ShortenNames().set(v)
      }
    },
    show_all_day: {
      get() {
        return ShowAllDay().get()
      },
      set(v) {
        ShowAllDay().set(v)
      }
    }
  }
}
</script>

<style scoped>

</style>
